export default __webpack_public_path__ + "media/images/icon_logout-c9c7b4344a015f7d03662f6c3b7aed71.png";